/**
 * Client helper — call once after a bulk submit loop when at least one item succeeded.
 */
export async function requestBulkListingBatchSubmittedNotification(
  accessToken: string,
  itemId: string,
): Promise<void> {
  const response = await fetch("/api/notifications/events/listing-submitted", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ itemId, batchSubmissionComplete: true }),
  });

  if (!response.ok) {
    const payload = (await response.json().catch(() => ({}))) as {
      error?: string;
    };
    throw new Error(
      payload.error ?? "Failed to notify admins about bulk submission",
    );
  }
}
